//====================================================
//  ProductControl
//====================================================
// theme/assets/product-control.js

"use strict";

function openCartModal(qty, error = null) {
	const modal = document.getElementById("add-to-cart-modal");

	modal.classList.add("open");

	// TODO: Add error message to modal
	if (error) {
		modal.querySelector(".error").innerText = error;
	}
}

Shopify.queue = [];

const productCtrl = {

	/**
	 * Function to run on page load
	 * Called at the end of the script
	 */
	onLoad: function () {
		// on page load, disable decrement button as the
		// default quantity is 1
		this.getDecrementBtn().disabled = true;
	},

	//----------------------------------------------------
	// Getters
	//----------------------------------------------------

	// Get current options from the product page
	getCurrentOptions: function () {
		return Array.from(
			document.querySelectorAll("*[data-single-option-selector]")
		).map(function (el) {
			let currentOption = {};
			currentOption.value = el.value;
			currentOption.index = el.dataset.index;

			return currentOption;
		});
	},

	getDecrementBtn: function () {
		return document.getElementById("decrementBtn");
	},

	/* Scope: Product single
	 Requirements:
	 - data-product-json: script tag with JSON product data (use {{ product | json }})

	 Get current variant from selected options
	 */
	getVariantFromOptions: function () {
		const selectedValues = this.getCurrentOptions();
		const product = JSON.parse(
			document.querySelector("*[data-product-json]").innerHTML
		);
		let found = false;

		product.variants.forEach(function (variant) {
			let satisfied = true;

			selectedValues.forEach(function (option) {
				if (satisfied) {
					satisfied = option.value === variant[option.index];
				}
			});

			if (satisfied) {
				found = variant;
			}
		});

		return found || null;
	},

	/* Scope: Product single
	 Requirements:
	 - data-product-price on product price HTML element

	 Update product price on variant switch
	 */

	// NOTE what do we need this for?
	updateProductPrice: function () {
		const currentVariant = productCtrl.getVariantFromOptions();
		const priceEl = document.querySelector("*[data-product-price]");
		priceEl.innerHTML = utilityFunctions.formatMoney(
			currentVariant.price,
			theme.moneyFormat
		);
	},

	//----------------------------------------------------
	// Quantity control functions
	//----------------------------------------------------

	/* Scope: Product single */
	// Decrement single product item quantity input field
	decrementSingleQty: function (el) {
		const qtyInput = el.parentNode.querySelector("input");
		decrementQty(qtyInput, this.getDecrementBtn());
	},

	/* Scope: Product single */
	// Increment single product item quantity input field
	incrementSingleQty: function (el) {
		const qtyInput = el.parentNode.querySelector("input");
		incrementQty(qtyInput, this.getDecrementBtn());
	},

	handleOnQtyChange: function (el) {
		let value = +el.value;
		if (value < 1 || isNaN(value)) {
			value = 1;
			el.value = value.toString();
		}
		const decrementBtn = this.getDecrementBtn();
		decrementBtn.disabled = value < 2;
	},

	//----------------------------------------------------
	// Add to cart functions
	//----------------------------------------------------

	async addProductsToCart() {
		const currentVariant = this.getVariantFromOptions();
		const productQty = document.querySelector("*[data-product-quantity]");

		this.addProductToQueue(currentVariant.id, productQty.value);
		await this.processAddToCartQueue();
	},

	/**
	 * Add a product (variant) to the end of the Shopify queue.
	 *
	 * @param variantId
	 * @param qty
	 */
	addProductToQueue: function (variantId, qty) {
		Shopify.queue.push({itemId: variantId, itemQty: qty});
	},

	/**
	 *  Adds one variant to the cart.
	 *  Called by the addProductsToCart function.
	 *
	 * @param variantId
	 * @param qty
	 * @returns {Promise<void>}
	 */
	addVariantToCart: async function (variantId, qty) {
		const response = await fetch("/cart/add.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({quantity: qty, id: variantId}),
		});
		const json = await response.json();
		console.log("response json:", json);
		if (response.ok) {
			const newQty = json.quantity;
			// this.updateCartIcon(newQty);
			openCartModal(newQty);
		} else {
			// this.updateCartIcon(0);
			openCartModal(0, "Error adding item to cart");
		}
	},

	/**
	 * Processes the Shopify queue to add items to the cart.
	 * @returns {Promise<void>}
	 */
	processAddToCartQueue: async function () {
		while (Shopify.queue.length) {
			const request = Shopify.queue.shift();
			await this.addVariantToCart(request.itemId, request.itemQty);
		}
	},

	// DESOMEX NOTE: Temporarily disabled. I will make it function later.
	updateCartIcon: function () {
		/*
		 fetch(window.Shopify.routes.root + 'cart.js')
		 .then(response => response.json())
		 .then(cart => {
		 let cartIcons = document.querySelectorAll('.cart-icon figcaption');
		 cartIcons.forEach(el => el.innerHTML = cart.item_count);
		 });
		 */
	},


};

document.addEventListener("DOMContentLoaded", function () {
	productCtrl.onLoad();
});
